import { render, staticRenderFns } from "./NoPhotoPlaceholder.vue?vue&type=template&id=d0fc5c02&scoped=true"
import script from "./NoPhotoPlaceholder.vue?vue&type=script&lang=js"
export * from "./NoPhotoPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./NoPhotoPlaceholder.vue?vue&type=style&index=0&id=d0fc5c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fc5c02",
  null
  
)

export default component.exports